import { Navigate, Outlet } from "react-router-dom";
import BackdropLoader from "../base/BackdropLoader";

interface Props {
  productLicensed: boolean | undefined;
}

const AuthLicenseGate: React.FC<Props> = ({ productLicensed }) => {
  const isLoading = productLicensed === undefined;

  if (isLoading) {
    return <BackdropLoader open={true} />;
  }

  if (!productLicensed) {
    return <Navigate to="/error" replace />;
  }

  return <Outlet />;
};

export default AuthLicenseGate;
